import { useEffect, useRef, useState } from "react";
import { Send, X, Lock } from "lucide-react";
import { api } from "@/lib/api";

export const InCallChat = ({ cs, meId, role, peerId, peerName, chatCoins, onClose }) => {
  const [text, setText] = useState("");
  const endRef = useRef(null);
  const msgs = cs.chats[peerId] || [];
  useEffect(() => { api.get(`/chat/${peerId}`).then((r) => cs.loadChat(peerId, r.data)).catch(() => null); }, [peerId]); // eslint-disable-line
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs.length]);
  const submit = (e) => { e.preventDefault(); const t = text.trim().slice(0, 50); if (!t) return; cs.sendChat(peerId, t); setText(""); };

  return (
    <div data-testid="in-call-chat" className="absolute inset-x-0 bottom-0 z-20 glass rounded-t-3xl border-t border-white/15 flex flex-col max-h-[55vh] fade-up">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/10">
        <div>
          <p className="text-sm font-bold text-white">{peerName} — ചാറ്റ്</p>
          <p className="text-[10px] text-white/60 inline-flex items-center gap-1"><Lock size={10} /> നമ്പർ/ഐഡി മാസ്ക് ചെയ്യും{role === "customer" && <> · ഒരു മെസ്സേജ് = <span className="font-num font-bold">₹{(chatCoins || 12) / 6}</span></>}</p>
        </div>
        <button type="button" data-testid="in-call-chat-close" onClick={onClose} className="w-8 h-8 rounded-full bg-white/10 text-white inline-flex items-center justify-center"><X size={14} /></button>
      </div>
      <div data-testid="in-call-chat-messages" className="flex-1 overflow-y-auto px-4 py-2 space-y-1.5 min-h-[120px]">
        {msgs.length === 0 && <p className="text-[11px] text-white/50 text-center mt-6">കോളിനിടെ ചെറിയ മെസ്സേജുകൾ അയക്കാം</p>}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.from_id === meId ? "justify-end" : "justify-start"}`}>
            <span className={`max-w-[75%] rounded-2xl px-3 py-1.5 text-sm ${m.from_id === meId ? "bg-[var(--accent-c)] text-[var(--accent-fg)] rounded-br-sm" : "bg-white/15 text-white rounded-bl-sm"}`}>{m.text}</span>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={submit} className="flex items-center gap-2 p-3 border-t border-white/10">
        <div className="relative flex-1">
          <input data-testid="in-call-chat-input" value={text} maxLength={50} onChange={(e) => setText(e.target.value.slice(0, 50))} placeholder="50 അക്ഷരങ്ങൾ വരെ..." className="w-full h-10 rounded-xl bg-white/10 border border-white/15 text-white placeholder:text-white/40 px-3 pr-12 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--accent-c)]" />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 font-num text-[10px] text-white/50">{text.length}/20</span>
        </div>
        <button type="submit" data-testid="in-call-chat-send" disabled={!text.trim()} className="btn-accent w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0 disabled:opacity-40"><Send size={16} /></button>
      </form>
    </div>
  );
};
